import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getRevenueReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import { reportRevenueReportCrumb } from 'utils/breadcrumbInfo';
import PageHeader from 'screens/components/basic/PageHeader';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import { getProductTypes } from 'actions/EntityActions';
import WithRouter from 'custom/withRouter';

class RevenueReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `RevenueReportBeginDate`);
        this.props.formInput(date, `RevenueReportEndDate`);
        this.props.getProductTypes();
    }

    componentDidUpdate(prevProps) {
        if (this.props.isCannabis != undefined && prevProps.isCannabis != this.props.isCannabis) {
            this.props.formInput("", "RevenueReportCategoryOption")
        }
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let category = this.props.categoryFilter || 0;
        let isCannabis = this.props.isCannabis;

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/revenuereport?beginDate=${beginDate}&endDate=${endDate}&branch=${branch}&isCannabis=${isCannabis}&category=${category}`, "revenuereport");
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getCategoryOptions = () => {
        return (this.props.category.list || []).map(item => {
            return {
                text: item.name,
                value: item.id.toString(),
                isCannabis: item.isCannabis
            };
        });
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let category = this.props.categoryFilter || 0;
        let isCannabis = this.props.isCannabis;

        this.props.getRevenueReport({ beginDate, endDate, pageNumber, pageSize, branch, category, isCannabis });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }

    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        const totalRow = this.props.revenueReport && this.props.revenueReport.list && this.props.revenueReport.list.length > 0 ? this.props.revenueReport.list[0].totalRows : 0;

        return (
            <Grid headerContent={reportRevenueReportCrumb}>
                <PageHeader title={LOOKUP.report.revenueReport.text}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-inventory-planner-revenue-report" />}
                    description={LOOKUP.report.revenueReport.description}
                />
                <Header
                    loggedBranch={this.props.loggedBranch}
                    branchOptions={this.props.brachOptions}
                    productCategories={this.props.categoryOptions} 
                    isCannabisOptions={this.props.isCannabisOptions}
                    isCannabis={this.props.isCannabis}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                />
                {
                    this.state.showBody &&
                    <p className="text-right mt-2 blue-text">
                        <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                    </p>
                }
                {
                    this.state.showBody && this.props.revenueReport &&
                    <CardSimple>
                        <Body
                            revenueReport={this.props.revenueReport}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                            loggedBranch={this.props.loggedBranch}
                            branchForm={this.props.branch}
                        />
                        <Pagination
                            length={totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    let categories = [];
    const cat = state.entity.productTypesList.length > 0 ? state.entity.productTypesList[0].categories : [];
    cat.map(item => {
        categories.push({
            text: item.name,
            value: item.id.toString(),
            isCannabis: item.isCannabis
        });
    });

    categories.sort((a, b) => {
        if (a.text < b.text)
            return -1;
        if (a.text > b.text)
            return 1;
        return 0;
    });

    categories.unshift({ text: "All", value: "0", isCannabis: false }, {text: "All", value: "0", isCannabis: true});

let isCannabis = [
    {
        text: "All", value: "2"
    },
    {
        text: "Cannabis", value: "1"
    },
    {
        text: "Non-Cannabis", value: "0"
    }
];

    return {
        brachOptions: brachOptions,
        revenueReport: state.reports.revenueReport,
        loggedBranch: state.common.branchId,
        beginDate: state.form.RevenueReportBeginDate,
        endDate: state.form.RevenueReportEndDate,
        branch: state.form.RevenueReportBranchOption,
        isCannabisOptions: isCannabis,
        isCannabis: state.form.RevenueReportIsCannabis,
        category: state.entity.productCategories,
        categoryFilter: state.form.RevenueReportCategoryOption,
        categoryOptions: categories
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getRevenueReport: model => dispatch(getRevenueReport(model)),
        getProductTypes: () => dispatch(getProductTypes()),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(RevenueReport));